import makePuzzle from '@main/factories/pages/makePuzzle';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { puzzle } = useData<Data>();

	return makePuzzle(puzzle);
}
